import React, { useEffect, useState } from 'react';
import { ButtonWithCounter, IconFilter, Tooltip } from '@paretogroup/tess';
import { useToggle } from '@shared/utils/toggle/toggle.hooks';
import { useHover } from '@shared/utils/hover/useHover.hooks';
import { useSegments } from '@domain/segments/segments.hooks';
import { STANDARD } from '@shared/constants/dashboard/campaign-table-constants';
import { FilterDrawer } from './filter-drawer';
import { buttonFilterStyles } from './campaigns-filter.styles';
import {
    CAMPAIGNS_FILTER_AUTO_TEST_IDS,
    CAMPAIGNS_FILTER_TEST_IDS,
    CAMPAIGNS_FILTER_TEXTS,
} from './campaigns-filter.constants';
import { getIconColor } from './campaigns-filter.utils';
import { useCampaignFilterRules } from './rules';

export const CampaignsFilter = () => {
    const [toggled, toggleModal, setToggled] = useToggle(false);
    const [isEnabled, setEnabled] = useState(false);

    const {
        isHovered,
        onMouseEnter,
        onMouseLeave,
    } = useHover();

    const { rulesCount } = useCampaignFilterRules();
    const { selectedGroup } = useSegments();

    const onClose = () => {
        setToggled(false);
    };

    const handleOnToggleModal = () => {
        if (isEnabled) {
            toggleModal();
        }
    };

    useEffect(() => {
        const enabled = selectedGroup.slug === STANDARD;

        setEnabled(enabled);
    }, [selectedGroup.slug]);

    const getRulesCount = () => (isEnabled ? rulesCount : 0);

    return (
        <>
            <Tooltip
                title={CAMPAIGNS_FILTER_TEXTS.TOOLTIP.DISABLED}
                disableHoverListener={isEnabled}
            >
                <div>
                    <ButtonWithCounter
                        size={18}
                        onClick={handleOnToggleModal}
                        style={buttonFilterStyles}
                        data-testid={CAMPAIGNS_FILTER_TEST_IDS.ICON_BUTTON}
                        data-auto-testid={CAMPAIGNS_FILTER_AUTO_TEST_IDS.ICON_BUTTON}
                        onMouseEnter={onMouseEnter}
                        onMouseLeave={onMouseLeave}
                        counter={getRulesCount()}
                    >
                        <IconFilter
                            primaryColor={getIconColor(isHovered, isEnabled)}
                            secondaryColor={getIconColor(isHovered, isEnabled)}
                            size={20}
                        />
                    </ButtonWithCounter>
                </div>
            </Tooltip>
            <FilterDrawer
                open={toggled}
                onClose={onClose}
            />
        </>
    );
};
